import { Shape, shapeDefaults } from './dom';
import { defined } from './utils';
import { CASCADING, CHANGE, CLICK, CONNECTION, CONNECTION_POINTS_EDITING_SNAP, DRAG, DRAG_END, DRAG_START, ITEMBOUNDSCHANGE, ITEMROTATE, MOUSE_ENTER, MOUSE_LEAVE, PAN, SELECT, TOOLTIP_HIDE, TOOLTIP_SHOW, ZOOM_END, ZOOM_START } from './constants';
export function copyDefaultOptions(mainOptions, elementOptions, fields) {
    let field;
    for (let idx = 0; idx < fields.length; idx++) {
        field = fields[idx];
        if (elementOptions && !defined(elementOptions[field])) {
            elementOptions[field] = mainOptions[field];
        }
    }
}
export const defaultOptions = {
    name: 'Diagram',
    theme: 'sass',
    layout: '',
    zoomRate: 0.1,
    zoom: 1,
    zoomMin: 0,
    zoomMax: 2,
    dataSource: {},
    draggable: true,
    template: '',
    autoBind: true,
    editable: {
        rotate: {},
        resize: {},
        text: true,
        tools: [],
        drag: {
            snap: {
                size: 10,
                angle: 10
            }
        },
        remove: true
    },
    pannable: {},
    selectable: {
        key: 'none'
    },
    tooltip: {
        delay: 200,
        // Inherited from JQuery Diagram, not in use here.
        enabled: true, format: '{0}'
    },
    copy: {
        enabled: true,
        offsetX: 20,
        offsetY: 20
    },
    tabIndex: 0,
    navigation: {
        disabled: false,
        smallStep: 1,
        largeStep: 5
    },
    accessibility: {
        role: 'graphics-document',
        ariaRoleDescription: 'Diagram'
    },
    shapeDefaults: shapeDefaults({ undoable: true, connectors: undefined }),
    connectionDefaults: {
        accessibility: {
            role: 'graphics-symbol',
            ariaRoleDescription: CONNECTION
        },
        editable: {
            tools: [],
            points: {
                snap: CONNECTION_POINTS_EDITING_SNAP
            }
        },
        tooltip: {
            visible: true
        },
        type: CASCADING
    },
    shapes: [],
    connections: []
};
export const domEvents = ['contextmenu', 'dblclick', 'pointerdown', 'pointermove', 'pointerup', 'pointercancel', 'pointerleave', 'touchstart', 'touchmove', 'touchend', 'touchcancel'];
export const events = [
    ZOOM_END,
    ZOOM_START,
    PAN, SELECT,
    ITEMROTATE,
    ITEMBOUNDSCHANGE,
    CHANGE,
    CLICK,
    MOUSE_ENTER,
    MOUSE_LEAVE,
    TOOLTIP_SHOW,
    TOOLTIP_HIDE,
    'toolBarClick',
    'save',
    'cancel',
    'edit',
    'remove',
    'undo',
    'redo',
    'add',
    'dataBound',
    ...domEvents,
    DRAG_START,
    DRAG,
    DRAG_END
];
export function splitDiagramElements(elements) {
    const connections = [];
    const shapes = [];
    let element, idx;
    for (idx = 0; idx < elements.length; idx++) {
        element = elements[idx];
        if (element instanceof Shape) {
            shapes.push(element);
        }
        else {
            connections.push(element);
        }
    }
    return {
        shapes: shapes,
        connections: connections
    };
}
export function preventDefault(e) {
    e.preventDefault();
}
export function elementOffset(element) {
    const rect = element.getBoundingClientRect();
    const doc = element.ownerDocument;
    const scrollLeft = doc.defaultView.scrollX || doc.documentElement.scrollLeft || 0;
    const scrollTop = doc.defaultView.scrollY || doc.documentElement.scrollTop || 0;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    };
}
export function outerWidth(element, includeMargins = false) {
    let widthValue = element.offsetWidth; // Width of the element with padding and border
    if (includeMargins) {
        const style = getComputedStyle(element);
        const marginLeft = parseFloat(style.marginLeft);
        const marginRight = parseFloat(style.marginRight);
        widthValue += marginLeft + marginRight;
    }
    return widthValue;
}
export function outerHeight(element, includeMargins = false) {
    let heightValue = element.offsetHeight;
    if (includeMargins) {
        const style = getComputedStyle(element);
        const marginTop = parseFloat(style.marginTop);
        const marginBottom = parseFloat(style.marginBottom);
        heightValue += marginTop + marginBottom;
    }
    return heightValue;
}
export function elementWidth(element) {
    const style = getComputedStyle(element);
    const widthValue = element.clientWidth; // Includes content + padding
    const paddingLeft = parseFloat(style.paddingLeft);
    const paddingRight = parseFloat(style.paddingRight);
    return widthValue - paddingLeft - paddingRight; // Only content
}
export function elementHeight(element) {
    const style = getComputedStyle(element);
    const heightValue = element.clientHeight;
    const paddingTop = parseFloat(style.paddingTop);
    const paddingBottom = parseFloat(style.paddingBottom);
    return heightValue - paddingTop - paddingBottom;
}
